"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _compose = _interopRequireDefault(require("./compose"));
var _style = require("./style");
const supportedShadowSizes = ['xs', 'sm', 'md', 'lg', 'sunken', 'flat', 'raised', 'floating'];
const themeColorKey = 'busbud.colors';
function getBoxShadow(value, props) {
  if (supportedShadowSizes.includes(value)) {
    const colorKey = props.boxShadowColor || 'subtle';
    // @ts-ignore This will be deleted after `Box` deprecation
    return props.theme.busbud.styles.shadow[colorKey][value];
  }
  return value;
}
const boxShadow = (0, _style.style)({
  prop: 'boxShadow',
  themeKey: 'busbud.styles.shadows.boxShadows',
  transform: getBoxShadow
});
const boxShadowColor = (0, _style.style)({
  prop: 'boxShadowColor',
  themeKey: themeColorKey,
  transform: () => ''
});
const shadows = (0, _compose.default)(boxShadow, boxShadowColor);
var _default = exports.default = shadows;